import { render, staticRenderFns } from "./investItem.vue?vue&type=template&id=654d6cfc&scoped=true&"
import script from "./investItem.vue?vue&type=script&lang=js&"
export * from "./investItem.vue?vue&type=script&lang=js&"
import style0 from "./investItem.vue?vue&type=style&index=0&id=654d6cfc&lang=less&scoped=true&"
import style1 from "./investItem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d6cfc",
  null
  
)

export default component.exports